export class NRIUtils {

    private static readonly numericalRiskValues = {
      '5.Very High': 1,
      '4.Relatively High': 2,
      '3.Relatively Moderate': 3,
      '2.Relatively Low': 4,
      '1.Very Low': 5,
      'No Rating': 6,
      'Not Applicable': 7,
      'Insufficient Data': 8
    };
  
    // Reverse mapping without numbers for fallback lookup
    private static readonly labelToNumberMap: Record<string, number> = {
      'Very High': 1,
      'Relatively High': 2,
      'Relatively Moderate': 3,
      'Relatively Low': 4,
      'Very Low': 5,
      'No Rating': 6,
      'Not Applicable': 7,
      'Insufficient Data': 8
    };
  
    public static riskValueColorsByNumbers = {
      1: '#f50000',   // Very High
      2: '#ff9426',   // Relatively High
      3: '#ffdd7b',   // Relatively Moderate
      4: '#ffeab3',   // Relatively Low
      5: '#d4f7a3',   // Very Low
    };
  
    public static getNumericRiskValue(textValue: string) {
      if (!textValue) return undefined;
  
      // Try exact match first (with prefix)
      let numVal = this.numericalRiskValues[textValue];
      if (numVal !== undefined) {
        return numVal;
      }
  
      // Fallback: strip any leading number + dot + space if present and try lookup without prefix
      const stripped = textValue.replace(/^\d+\.\s*/, '');
      numVal = this.labelToNumberMap[stripped];
      return numVal;
    }
  
  }
  